"use client";
import Breadcrumb, { BreadcrumbItem } from "@/components/common/breadcrumb";
import Image from "next/image";
import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

import Beer from "../../../public/assets/client/beer/abinbev.webp";
import Beer2 from "../../../public/assets/client/beer/godfather.webp";
import Beer3 from "../../../public/assets/client/beer/cg.png";
import Beer4 from "../../../public/assets/client/beer/grag-trader.png";
import Beer5 from "../../../public/assets/client/beer/ub.png";

import Food1 from "../../../public/assets/client/food/capital-foods.png";
import Food2 from "../../../public/assets/client/food/gd-foods.png";
import Food3 from "../../../public/assets/client/food/dabur.webp";
import Food4 from "../../../public/assets/client/food/masterchow.png";
import Food5 from "../../../public/assets/client/food/vrb.png";

import Liquor1 from "../../../public/assets/client/liquor/nicoles.jpg";
import Liquor2 from "../../../public/assets/client/liquor/globus.png";
import Liquor3 from "../../../public/assets/client/liquor/nicoles.png";
import Liquor4 from "../../../public/assets/client/liquor/pernod-richard.png";
import Liquor5 from "../../../public/assets/client/liquor/redico.png";

import Pharma1 from "../../../public/assets/client/pharma/biogenetic.png";
import Pharma2 from "../../../public/assets/client/pharma/dabur.png";
import Pharma3 from "../../../public/assets/client/pharma/harmony.png";
import Pharma4 from "../../../public/assets/client/pharma/luthra.png";
import Pharma5 from "../../../public/assets/client/pharma/shriji.png";

gsap.registerPlugin(ScrollTrigger);

const Clients = () => {
  const breadcrumbItems: BreadcrumbItem[] = [
    { label: "Home", href: "/" },
    { label: "Clients" },
  ];

  const categories = [
    { name: "Beer", images: [Beer, Beer2, Beer3, Beer4, Beer5] },
    { name: "Food", images: [Food1, Food2, Food3, Food4, Food5] },
    { name: "Liquor", images: [Liquor1, Liquor2, Liquor3, Liquor4, Liquor5] },
    // { name: "Pharma", images: [Pharma1, Pharma2, Pharma3, Pharma4, Pharma5] },
  ];

  const cardsRef = useRef<HTMLDivElement[]>([]);

  useEffect(() => {
    cardsRef.current.forEach((card) => {
      gsap.fromTo(
        card,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: card,
            start: "top 90%",
            end: "bottom 10%",
            toggleActions: "play reverse play reverse", // animation repeats
            markers: false,
          },
        }
      );
    });
  }, []);

  return (
    <div className="xl:mt-17 mt-1920-20">
      <Breadcrumb title="Clients" items={breadcrumbItems} />

      <section className="pt-[50px] pb-[120px] px-[20px]">
        <div className="container mx-auto flex flex-col gap-10">
          {categories.map((category, idx) => (
            <div
              key={idx}
              ref={(el) => {
                if (el) cardsRef.current[idx] = el;
              }}
              className="shadow-2xl p-5 border border-gray-200 rounded-xl bg-white"
            >
              <h2 className="text-xl font-bold mb-5">{category.name}</h2>
              <div className="grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-5">
                {category.images.map((img, index) => (
                  <div key={index} className=" rounded-lg bg-gray-50">
                    <Image
                      src={img}
                      alt={`${category.name} ${index + 1}`}
                      className="object-contain w-full  rounded-lg"
                    />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* <div className="py-[50px]"></div> */}
    </div>
  );
};

export default Clients;
